import Http from "../Http";
import { INSPECTION_URL } from "../Helper";

export function getTrustedDealerProfileData(profile_id) {
    return (dispatch) =>
      new Promise((resolve, reject) => {
        Http.get(INSPECTION_URL + 'get_trusted_dealer_profile/' + profile_id)
          .then((res) => {
            return resolve(res.data);
          })
          .catch((err) => {
            return reject(err);
          });
      });
}

export function updateTrustedDealerProfile(values) {
    return (dispatch) =>
      new Promise((resolve, reject) => {
        Http.post(INSPECTION_URL + 'update_trusted_dealer_profile/', values)
          .then((res) => {
            return resolve(res.data);
          })
          .catch((err) => {
            return reject(err);
          });
      });
}

export function getDealerInquiries(profile_id) {
    return (dispatch) =>
      new Promise((resolve, reject) => {
        Http.get(INSPECTION_URL + 'get_dealer_inquiries/?profile_id=' + profile_id)
          .then((res) => {
            return resolve(res.data);
          })
          .catch((err) => {
            return reject(err);
          });
      });
}

export function updateInquiryStatus(inquiry_id, status) {
    return (dispatch) =>
      new Promise((resolve, reject) => {
        Http.post(`${INSPECTION_URL}update_dealer_inquiry_status/?inquiry_id=${inquiry_id}&status=${status}`, { inquiry_id, status })
          .then((res) => {
            return resolve(res.data);
          })
          .catch((err) => {
            return reject(err);
          });
      });
}

export function deleteDealerInquiry(inquiry_id) {
    return (dispatch) =>
      new Promise((resolve, reject) => {
        Http.post(`${INSPECTION_URL}delete_dealer_inquiry/?inquiry_id=${inquiry_id}`, { inquiry_id })
          .then((res) => {
            return resolve(res.data);
          })
          .catch((err) => {
            return reject(err);
          });
      });
}

export function getDealerRequestedInspections(dealerId, { page = 1, pageSize = 10, search = "", status = "", date_from = "", date_to = "" } = {}) {
    return (dispatch) =>
      new Promise((resolve, reject) => {
        Http.get(INSPECTION_URL + 'get_dealer_requested_inspections/', {
          params: {
            dealer_id: dealerId || '',
            page,
            per_page: pageSize,
            search,
            status,
            date_from,
            date_to
          }
        })
          .then((res) => {
            return resolve(res.data);
          })
          .catch((err) => {
            return reject(err);
          });
      });
}

export function agreeCodeOfConduct() {
    return (dispatch) =>
      new Promise((resolve, reject) => {
        Http.post(INSPECTION_URL + 'agree_code_of_conduct/')
          .then((res) => {
            return resolve(res.data);
          })
          .catch((err) => {
            return reject(err);
          });
      });
}
